import { MenuItem, Select } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { getVar } from "../../http/api/VarAPI";

const infoTableCellSx = {
  fontSize: 17,
};

// 検索フォーム
function SearchForm(props) {
  const { searchData } = props;

  const [varTypes, setVarTypes] = useState([]);

  const handleChange = (event) => {
    searchData.update("varDiv", event.target.value);
  };

  useEffect(() => {
    SetupVarTypes();
  }, []);

  async function SetupVarTypes() {
    try {
      const response = await getVar({ varDiv: 0 });
      const responseVarTypes = response.listVarInfo.map((v) => ({
        key: v.varCd,
        value: v.varValue1,
      }));
      setVarTypes(responseVarTypes);
    } catch {
      setVarTypes([]);
    }
  }

  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      フィルター
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs="auto">
            <Select
              value={searchData.Value.varDiv}
              onChange={handleChange}
              style={{ width: 350 }}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PaperProps: {
                  style: {
                    maxHeight: 300, // Set max height
                    overflow: "auto", // Enable scroll
                    width: 350, // Adjust the width as needed
                  },
                },
              }}
            >
              {varTypes.map((option) => (
                <MenuItem key={option.key} value={option.key}>
                  {option.key} - {option.value}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default SearchForm;
